// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__2Kziz","submit":"styles_submit__3O69N","forms":"styles_forms__1Xfg-","edit":"styles_edit__1ls3d","editBtn":"styles_editBtn__rC36-"};